// extracted by mini-css-extract-plugin
export default {"stop-auction-modal":"stop-auction-modal_stop-auction-modal__YGzIL","gray-dark":"stop-auction-modal_gray-dark__-0rJc"};